module.exports = __webpack_public_path__ + "img/lasalle.43717c6f.png";